/*
 * Utilitas kecil antarmuka (AzZahra CBT, aplikasi lama).
 *  - Tombol salin: elemen .az-copy dengan atribut data-copy="teks" (boleh hasil interpolasi AngularJS).
 *    Menyalin ke clipboard (Clipboard API, cadangan execCommand), ikon berubah menjadi ✓ sesaat.
 */
(function () {
    function salinTeks(teks) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(teks);
        }
        return new Promise(function (ok, gagal) {
            var ta = document.createElement('textarea');
            ta.value = teks;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy') ? ok() : gagal(new Error('copy')); } catch (e) { gagal(e); }
            document.body.removeChild(ta);
        });
    }
    window.azSalin = salinTeks;

    document.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.az-copy') : null;
        if (!btn) return;
        e.preventDefault();
        var teks = btn.getAttribute('data-copy') || '';
        if (!teks) return;
        var ikon = btn.querySelector('i');
        var judul = btn.getAttribute('title') || '';
        salinTeks(teks).then(function () {
            btn.classList.add('az-copied');
            if (ikon) ikon.className = 'fa fa-check';
            btn.setAttribute('title', 'Tersalin');
            clearTimeout(btn.__azT);
            btn.__azT = setTimeout(function () {
                btn.classList.remove('az-copied');
                if (ikon) ikon.className = 'fa fa-copy';
                btn.setAttribute('title', judul === 'Tersalin' ? 'Salin' : judul);
            }, 1500);
        }, function () {
            btn.classList.add('az-copy-gagal');
            setTimeout(function () { btn.classList.remove('az-copy-gagal'); }, 1500);
        });
    });
})();
